<ux-tag class="tag_no-text" [model]="tagCopy()"></ux-tag>
<div class="setting-tag-item__text">
  <input
    type="text"
    class="input input_theme-1 input_border-focus"
    [(ngModel)]="tagCopy().name"
    (focus)="onFocus()"
    (blur)="onBlur()"
    placeholder="Добавить новый тег"
    (keydown.enter)="onSave()"
  />
</div>
@if (!isEditMode()) {
  <div class="setting-tag-item__colors">
    @for (item of cssClasses; track item) {
      <div class="setting-tag-item__color-wrapper">
        <div
          [ngClass]="item.cssClass"
          [class.setting-tag-item__color_active]="item.cssClassApi === tagCopy().cssClass"
          (click)="onChangeCssClass(item.cssClassApi)"
          class="setting-tag-item__color"
        ></div>
      </div>
    }
  </div>
  @if (!isNew) {
    <span class="setting-tag-item__delete" (click)="onDelete()"><i class="icon-close"></i></span>
  }
}
